module.exports = __webpack_public_path__ + "img/escudo-nl2.1cb8fc1d.webp";